import styles from './index.module.less';
import Image from 'next/image';
const Index: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-search-range'];
  if (!showContent.title) {
    return null;
  }
  return (
    <div className={styles.container}>
      <Image src={showContent.imgPath} alt={showContent.title} width={343} height={216} />
      <div>
        <h2>{showContent.title}</h2>
        <p>{showContent.desc}</p>
      </div>
    </div>
  );
};

export default Index;
